import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import shortid from "shortid";
import { Button, Card, Col, Descriptions, Row, Tooltip } from "antd";
import { numberToReal } from "../../../../helpers/functions";
import { solveDuplicityMovement } from "../actions";

function renderButtons(props, record, id) {
  const { solveDuplicityMovement } = props;
  const { Registro } = record;

  if (Registro === "61R") {
    return (
      <>
        {/* <Button ghost onClick={() => solveDuplicityMovement(id, 3, 2)}>
          Remover Documento Fiscal
        </Button>

        <Button ghost className='mx-2' onClick={() => solveDuplicityMovement(id, 3, 4)}>
          Remover SINTEGRA
        </Button> */}

        <Tooltip title='Nesta opção você autoriza o sistema a SOMAR os valores do SINTEGRA com os valores dos arquivos XML'>
          <Button onClick={() => solveDuplicityMovement(id, 1, 4)}>Prosseguir</Button>
        </Tooltip>
      </>
    );
  }
}

const DrawerMovement = props => {
  const {
    data: { DuplicidadeMovimentacao, ValorDuplicadoMovimentacao },
    id
  } = props;
  const { solveDuplicityMovement } = props;
  let dataSource;

  if (DuplicidadeMovimentacao) {
    dataSource = ValorDuplicadoMovimentacao.map(item => {
      item.TotalDocumentoFiscal = numberToReal(item.ValorTotalDocumentoFiscal);
      item.TotalObrigacaoAcessoria = numberToReal(item.ValorTotalObrigacaoAcessoria);
      return item;
    });
  }

  return (
    <Card
      className='ant-card--warning'
      title='Detectamos movimentação duplicada entre o arquivo SINTEGRA e os DOCUMENTOS FISCAIS (xml)'
      bordered={false}
    >
      {dataSource.map(item => {
        return (
          <Fragment key={shortid.generate()}>
            <Row gutter={16}>
              <Col xl={12} lg={24}>
                <Card className='ant-card--ghost-silver' title='Documento Fiscal (xml)'>
                  <Descriptions
                    layout='vertical'
                    column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                  >
                    <Descriptions.Item cl label='Modelo'>
                      {item.Modelo}
                    </Descriptions.Item>
                    <Descriptions.Item label='Valor'>
                      {numberToReal(item.ValorTotalDocumentoFiscal)}
                    </Descriptions.Item>
                  </Descriptions>
                  <div style={{ width: "100%", textAlign: "right", display: "block" }}>
                    <Button
                      className='btn--danger-white'
                      onClick={() => solveDuplicityMovement(id, 3, 2)}
                    >
                      Remover Documento Fiscal
                    </Button>
                  </div>
                </Card>
              </Col>

              <Col xl={12} lg={24}>
                <Card className='ant-card--ghost-silver' title='SINTEGRA'>
                  <Descriptions
                    layout='vertical'
                    column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
                  >
                    <Descriptions.Item label='Registro'>{item.Registro}</Descriptions.Item>
                    <Descriptions.Item label='Valor'>
                      {numberToReal(item.ValorTotalObrigacaoAcessoria)}
                    </Descriptions.Item>
                  </Descriptions>
                  <div style={{ width: "100%", textAlign: "right", display: "block" }}>
                    <Button
                      className='btn--danger-white'
                      onClick={() => solveDuplicityMovement(id, 3, 4)}
                    >
                      Remover SINTEGRA
                    </Button>
                  </div>
                </Card>
              </Col>
            </Row>
            <div className='ant-card__footer'>{renderButtons(props, item, id)}</div>
          </Fragment>
        );
      })}
    </Card>
  );
};

const mapStateToProps = state => ({
  statusDelete: state.results.status
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      solveDuplicityMovement
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DrawerMovement));
